/**
 * Maison Grès — blocked stay dates (product metafield: custom.blocked_stay_dates).
 */
(function () {
  function pad(n) {
    return String(n).padStart(2, '0');
  }

  function toYMD(d) {
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
  }

  function parseYMD(s) {
    if (!s) return null;
    const [y, m, d] = String(s).trim().split('-').map(Number);
    if (!y || !m || !d) return null;
    return new Date(y, m - 1, d);
  }

  function addDays(date, days) {
    const next = new Date(date);
    next.setDate(next.getDate() + days);
    return next;
  }

  function startOfToday() {
    const now = new Date();
    return new Date(now.getFullYear(), now.getMonth(), now.getDate());
  }

  function normalizeRulesInput(raw) {
    if (!raw) return '';
    if (Array.isArray(raw)) {
      return raw.map((line) => String(line).trim()).filter(Boolean).join('\n');
    }
    return String(raw);
  }

  function expandRules(raw) {
    const blocked = new Set();
    const text = normalizeRulesInput(raw);
    if (!text) return blocked;

    text.split(/\r?\n/).forEach((line) => {
      const trimmed = line.trim();
      if (!trimmed) return;

      const range = trimmed.match(/^(\d{4}-\d{2}-\d{2})\s+to\s+(\d{4}-\d{2}-\d{2})$/i);
      if (range) {
        let cursor = parseYMD(range[1]);
        const end = parseYMD(range[2]);
        if (!cursor || !end || end < cursor) return;
        while (cursor <= end) {
          blocked.add(toYMD(cursor));
          cursor = addDays(cursor, 1);
        }
        return;
      }

      if (/^\d{4}-\d{2}-\d{2}$/.test(trimmed)) {
        blocked.add(trimmed);
      }
    });

    return blocked;
  }

  function isPastDay(date) {
    return date < startOfToday();
  }

  function isNightBlocked(ymd, blockedSet) {
    return blockedSet.has(ymd);
  }

  function isDayUnavailable(date, blockedSet) {
    const ymd = toYMD(date);
    return isPastDay(date) || isNightBlocked(ymd, blockedSet);
  }

  /** Stay nights: check-in inclusive, check-out exclusive. */
  function stayHasBlockedNight(checkIn, checkOut, blockedSet) {
    if (!checkIn || !checkOut || checkOut <= checkIn) return false;
    let cursor = new Date(checkIn);
    while (cursor < checkOut) {
      if (isNightBlocked(toYMD(cursor), blockedSet)) return true;
      cursor = addDays(cursor, 1);
    }
    return false;
  }

  function checkoutFromNights(checkIn, nights) {
    if (!checkIn || !nights) return null;
    return addDays(checkIn, Math.max(1, Number(nights) || 1));
  }

  window.MaisonAvailability = {
    toYMD,
    parseYMD,
    addDays,
    startOfToday,
    expandRules,
    isPastDay,
    isNightBlocked,
    isDayUnavailable,
    stayHasBlockedNight,
    checkoutFromNights
  };
})();
